module.exports = __webpack_public_path__ + "img/image46.872d5f4a.png";